import { Col, Form, Input, Row, Switch } from "antd";
import React from "react";

export function NewVendorForm(props) {
  const [financial, setFinancial] = React.useState(false);

  return (
    <Form
      layout="vertical"
      id="vendorForm"
      ref={props.formRef}
      // onFinish={AddVendor}
    >
      <Row justify="space-between" className="py-2">
        <strong
          className="align-items-center d-flex"
          style={{ fontSize: "16px" }}
        >
          Basic Details
        </strong>
      </Row>
      <Row gutter={24}>
        <Col sm={24}>
          <Form.Item
            name={"name"}
            label="Vendor Business Name"
            rules={[
              {
                required: true,
                message: "Vendor Business Name is required",
              },
            ]}
          >
            <Input placeholder="e.g. MDepot Furnishings" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col sm={24}>
          {/* <Form.Item
            name={"category"}
            rules={[
              {
                required: true,
                message: "Vendor Business Name is required",
              },
            ]}
            label="Category"
          >
            <Select mode="multiple" placeholder="Select Category">
              {categoryOptions}
            </Select>
          </Form.Item> */}

          <Form.Item name={"category"} label="Category">
            <Input placeholder="e.g. Laminates" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col sm={12}>
          <Form.Item
            name={"contact_person"}
            label="Contact person name"
            rules={[
              {
                pattern: /^[A-Za-z]+[A-Za-z ]*$/,
                message: "Enter valid person name",
              },
            ]}
          >
            <Input placeholder="Contact person name" />
          </Form.Item>
        </Col>
        <Col sm={12}>
          <Form.Item
            name={"vendor_code"}
            label="Vendor Code"
            rules={[
              {
                required: true,
                message: "Vendor Code is required",
              },
            ]}
          >
            <Input placeholder="Vendor Code" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col sm={12}>
          <Form.Item
            name={"contact"}
            label="Phone Number"
            rules={[
              {
                required: true,
                pattern: /^[1-9]\d{9}$/gi,
                message: "Phone Number is required",
              },
            ]}
          >
            <Input placeholder="Phone Number" />
          </Form.Item>
        </Col>
        <Col sm={12}>
          <Form.Item
            name={"email"}
            label="Email"
            rules={[
              {
                required: true,
                pattern:
                  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                message: "Email is required",
              },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col sm={24}>
          <Form.Item name={"billing_address"} label="Address">
            <Input placeholder="Enter your billing address here." />
          </Form.Item>
        </Col>
      </Row>{" "}
      <Row gutter={24}>
        <Col sm={24}>
          <Form.Item
            name={"pincode"}
            label="Pincode"
            rules={[
              {
                required: true,
                pattern: /^[1-9]\d{5}$/gi,

                message: "Enter a valid pincode",
              },
            ]}
          >
            <Input placeholder="Enter your pincode here" />
          </Form.Item>
        </Col>
      </Row>
      <strong
        className="pb-2 d-flex align-items-center"
        style={{ fontSize: "16px" }}
      >
        <div style={{ marginRight: 15 }}>Financial Details</div>
        <Switch
          checked={financial}
          onChange={(e) => {
            setFinancial(e);
          }}
        />
      </strong>
      {financial ? (
        <>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"bank_account_number"}
                label="Bank Account Number"
                rules={[
                  {
                    pattern: /^[0-9]{9,18}$/,
                    message: "Enter valid Bank account number",
                  },
                ]}
              >
                <Input placeholder="Bank Account Number" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"bank_account_holder"} label="Bank Holder Name">
                <Input placeholder="Bank Holder Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"bank_ifsc"}
                label="IFSC Code"
                rules={[
                  {
                    pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                    message: "Enter valid IFSC code",
                  },
                ]}
              >
                <Input placeholder="IFSC Code" />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item name={"billing_address"} label="Billing Address">
                <Input placeholder="Billing Address" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"gst"}
                label="GST Number"
                rules={[
                  {
                    pattern:
                      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                    message: "Enter valid GST Number",
                  },
                ]}
              >
                <Input
                  placeholder="GST Number"
                  // After the user is done typing, try to extract the PAN number
                  // from the GST number
                  onBlur={(e) => {
                    const gst = e.target.value;
                    if (gst.length === 15) {
                      const pan = gst.slice(2, 12);
                      props.formRef.current?.setFieldsValue({
                        pan_number: pan,
                      });
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"pan_number"}
                label="PAN Number"
                rules={[
                  {
                    pattern: /[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                    message: "Enter valid PAN Number",
                  },
                ]}
              >
                <Input placeholder="PAN Number" />
              </Form.Item>
            </Col>
          </Row>
        </>
      ) : null}
    </Form>
  );
}
